const VERSION = "17.0.0";
export {
  VERSION
};
//# sourceMappingURL=version.js.map
